import i18n from "./i18n";
import { localStorage } from '@utils';
import { ENGLISH_LANGUAGE_CODE_LK } from '@constants';

/**
 * Change app language
 *
 * @param {string} languageTag - one of "en"|"my"|"ch"
 */
export function changeLocale(languageTag) {
    localStorage.setUserPreferedLanguage(languageTag);
    i18n.changeLanguage(languageTag);
}

/**
 * Reset Locale to english
 */
export function resetLocale() {
    const languageTag = ENGLISH_LANGUAGE_CODE_LK;
    localStorage.setUserPreferedLanguage(languageTag);
    i18n.changeLanguage(languageTag);
}

/**
 *  get current used locale
 * @return { en|my|ch}
 */
export function getCurrentLocale() {
    return i18n.language;
}
